import React, { useState, useRef } from 'react'
import { Box } from '@hub/box'
import { CoreContainer } from '@hub/core-container'
import { Stack } from '@hub/stack'
import { useToken } from '@hub/design-system-base'
import { LinkItem, OpenHamburgerMenuAtPathType, RootPathType } from '../types'
import { NavLink } from './nav-link'
import { Overlay } from './overlay'

interface NavLinksProps {
  primaryLinks?: LinkItem[]
  tertiaryLinks?: LinkItem[]
  tabKey: RootPathType
  label?: string
  openHamburgerMenuAtPath: OpenHamburgerMenuAtPathType
}

export const NavLinks: React.FC<NavLinksProps> = ({
  openHamburgerMenuAtPath,
  primaryLinks,
  tertiaryLinks,
  label,
}) => {
  const menuZIndex = useToken('zIndices', 'menu')
  const containerRef = useRef<HTMLElement>(null)
  const [openId, setOpenId] = useState('')

  return (
    <>
      <Box
        as={props => <nav {...props} ref={containerRef} />}
        aria-label={label}
        sx={{
          height: 'size-full',
          position: 'relative',
          zIndex: menuZIndex,
        }}
      >
        {primaryLinks || tertiaryLinks ? (
          <CoreContainer
            fadeOutOverflow={[true, true, false]}
            as={props => (
              <Stack
                {...props}
                as="ul"
                direction="row"
                gap="spacing-0"
                align="flex-start"
                shouldWrapChildren={false}
                flexGrow={0}
              />
            )}
            sx={{
              height: 'size-full',
              fontSize: 'font-sm',
              overflowX: ['scroll', null, 'hidden'],
              overflowY: 'hidden',
              position: 'relative',
            }}
          >
            {primaryLinks?.map((item, index) => (
              <NavLink
                key={`primary-${index}`}
                item={item}
                index={index}
                openHamburgerMenuAtPath={openHamburgerMenuAtPath}
                megaMenuPortalRef={containerRef}
                openId={openId}
                setOpenId={setOpenId}
              />
            ))}

            {tertiaryLinks && tertiaryLinks.length ? (
              <Stack
                as="li"
                direction="row"
                justify="flex-end"
                shouldWrapChildren={false}
                flexGrow={0}
                sx={{ flexGrow: 1, height: 'size-full' }}
              >
                <Stack
                  as="ul"
                  direction="row"
                  shouldWrapChildren={false}
                  flexGrow={0}
                  sx={{ height: 'size-full' }}
                >
                  {tertiaryLinks?.map((item, index) => (
                    <NavLink
                      key={`secondary-${index}`}
                      item={item}
                      index={index}
                      openHamburgerMenuAtPath={openHamburgerMenuAtPath}
                      megaMenuPortalRef={containerRef}
                      openId={openId}
                      setOpenId={setOpenId}
                    />
                  ))}
                </Stack>
              </Stack>
            ) : null}
          </CoreContainer>
        ) : null}
      </Box>
      <Overlay
        megaMenuPortalRef={containerRef}
        isOpen={openId !== ''}
        onMouseEnter={() => setOpenId('')}
      />
    </>
  )
}
